import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppTitleConfig = {
    baseHtmlClass: "online_app__title",
    selector: ".online_app__title",
};

export class OnlineAppTitle extends OnlineAppComponent {
    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppTitleConfig);
        this.baseTitle = onlineApp.name;
    }

    render() {
        const title = this.renderTitle();
        this.conditionallySetHtmlClassState(!title, "empty");
        this.element.innerHTML = `<h2>${this.renderTitle()}</h2>`;
    }

    renderTitle() {
        const title = this.readStateMachineValue("title");
        if (!!title) return title;
        if (this.baseTitle) return this.baseTitle;
        return "";
    }

}

export function getTitle(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppTitle(element, onlineApp);
}
